
import { TablaListadoUsuarios } from "../components";
import { LayoutCrearDoc } from "../../layouts";
import { BuscadorXTermino } from "../../components/buscadores";
import { useNavigate } from "react-router-dom";
import { useListMisClientes } from "../../../hooks/cache";





export const MisClientes = () => {


    const navigate = useNavigate();
    const { data, isLoading, page, termino, chagePage, chageTermino } = useListMisClientes();
    
        
    const handleNavegar = () => {
        navigate(`/super/crearcliente`);
    }


    return (

        <LayoutCrearDoc titulo='Listado Mis Clientes' funcion={ handleNavegar }>
            {(isLoading)
            ?   <h1>Cargando información...</h1>
            :   <>
                <BuscadorXTermino mT={3} termino={termino} chageTermino={chageTermino} texto="cliente" playhol="nombre ciudad movil cedula" />
                <TablaListadoUsuarios data={data || []} chagePage={chagePage} page={page} />
                </>
            }
        </LayoutCrearDoc>

    )


}
